import { render } from "./SetNewPass.vue?vue&type=template&id=818b8388&ts=true"
import script from "./SetNewPass.vue?vue&type=script&lang=ts"
export * from "./SetNewPass.vue?vue&type=script&lang=ts"

import "./SetNewPass.vue?vue&type=style&index=0&id=818b8388&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__